export const STATE_LIST = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN',
    'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC',
    'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];

export const MARITAL_STATUSES = ['SINGLE', 'MARRIED', 'SEPARATED', 'HOUSEHOLD_HEAD', 'WIDOWED', 'NOT_SURE']

export const DEPENDANT_RELATIONS = ['SON', 'DAUGHTER', 'STEPCHILD', 'FOSTER_CHILD', 'GRANDCHILD', 'GRANDPARENT', 'PARENT_OR_IN_LAW', 'BROTHER', 'HALF_BROTHER',
    'STEPBROTHER', 'SISTER', 'HALF_SISTER', 'STEPSISTER', 'UNCLE', 'AUNT', 'NEPHEW', 'NIECE', 'OTHER']

export const COMPANY_TYPES = ['LLC', 'S_CORP', 'C_CORP', 'PARTNERSHIP', 'TRUST_ESTATE', 'NONPROFIT']